export default __webpack_public_path__ + "static/media/PayU.a38815a6.svg";